import React from 'react'
import { cn } from '#app/utils/misc.js'

export const BlockHeader = ({ text }: { text: string }) => {
	return <h2 className="text-2xl font-bold text-muted-foreground">{text}</h2>
}

export const BlockText = ({ text }: { text: string }) => {
	return <span className="truncate font-semibold">{text}</span>
}

export const BlockTextSecondary = ({
	text,
	noTruncate,
}: {
	text: string
	noTruncate?: boolean
}) => {
	return (
		<span className={cn('text-xs', !noTruncate && 'truncate')}>{text}</span>
	)
}

export const BlockTextContainer = React.forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
	<div
		ref={ref}
		className={cn('grid flex-1 text-left text-sm leading-tight', className)}
		{...props}
	/>
))

export const BlockTextStack = React.forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement> & {
		text: string
		textSecondary?: string | null
		textTertiary?: string | null
	}
>(({ text, textSecondary, textTertiary, className, ...props }, ref) => {
	return (
		<div
			ref={ref}
			className={cn('grid flex-1 text-left text-sm leading-tight', className)}
			{...props}
		>
			<BlockText text={text} />
			{textSecondary && <BlockTextSecondary text={textSecondary} />}
			{textTertiary && <BlockTextSecondary text={textTertiary} />}
		</div>
	)
})

export const BlockEmpty = React.forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement> & { text: string }
>(({ text, className, ...props }, ref) => (
	<div
		ref={ref}
		className={cn('flex flex-1 items-center justify-center', className)}
		{...props}
	>
		<BlockHeader text={text} />
	</div>
))
BlockEmpty.displayName = 'BlockEmpty'
